module.exports = __webpack_public_path__ + "img/ssyx_13.c8dda09c.jpg";